import { type IAgentMemberQuery } from 'application/querySchemas/IAgentMemberQuery';
import { type IAgentUserTokenRepository } from 'application/repositorySchemas/IAgentUserTokenRepository';
import { type IAgentMemberListClient, IGetResponse } from 'interfaceAdapter/gatewaySchemas/IAgentMemberListClient';
import {
    type IAgentUserClient,
    IGetResponse as IAgentUserResponse,
} from 'interfaceAdapter/gatewaySchemas/IAgentUserClient';
import { inject, injectable } from 'tsyringe';

@injectable()
export class AgentMemberQuery implements IAgentMemberQuery {
    constructor(
        @inject('IAgentUserTokenRepository')
        public readonly agentUserToken: IAgentUserTokenRepository,
        @inject('IAgentMemberListClient')
        public readonly agentMemberListClient: IAgentMemberListClient,
        @inject('IAgentUserClient')
        public readonly agentUserClient: IAgentUserClient,
    ) {}

    public async fetchList(): Promise<IGetResponse['data']> {
        const { data, message } = await this.agentMemberListClient.get({
            token: this.agentUserToken.get() || '',
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }

    public async fetchUser(userId: number): Promise<IAgentUserResponse['data']> {
        const { data, message } = await this.agentUserClient.get({
            token: this.agentUserToken.get() || '',
            userId,
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }
}
